<template>
    <!-- 화면에 고정하지 않고 본문 위에 둔다(왼쪽 아래 선물 버튼, 오른쪽 아래 TOP·채널톡을 가리지 않게) -->
    <v-sheet v-if="shows" color="grey lighten-4" class="client-push-banner">
        <v-container class="py-8px">
            <v-row no-gutters align="center" class="flex-nowrap">
                <v-col class="font-size-14 pr-8px">
                    <v-icon small color="primary" class="mr-4px">mdi-bell-ring-outline</v-icon>
                    {{ texts.banner }}
                </v-col>
                <v-col cols="auto">
                    <v-btn small color="primary" elevation="0" :loading="loading" :disabled="loading" @click="enable">{{ texts.button }}</v-btn>
                </v-col>
                <v-col cols="auto" class="ml-4px">
                    <v-btn icon small aria-label="닫기" @click="hide"><v-icon small>mdi-close</v-icon></v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-sheet>
</template>

<script>
import { isSupported, pushState, enableWithAlert, PUSH_TEXTS } from "@/plugins/push";

const COOKIE_KEY = "push-banner";

export default {
    props: {
        logon: { type: Boolean, default: false },
    },
    data: () => ({
        texts: PUSH_TEXTS,
        supported: false,
        hidden: false,
        loading: false,
    }),
    computed: {
        // 권한은 push.js 의 공유 상태를 읽는다(받은 선물 목록 버튼에서 허용해도 바로 사라지게)
        permission() {
            return pushState.permission;
        },
        shows() {
            return this.logon && this.supported && this.permission == "default" && !this.hidden;
        },
    },
    methods: {
        async enable() {
            if (this.loading) return;
            this.loading = true;
            // enableWithAlert 가 권한 요청을 동기로 먼저 부른다. 이 앞에 await 를 두지 않는다
            await enableWithAlert();
            this.loading = false;
        },

        hide() {
            this.$cookies.set(COOKIE_KEY, "hidden", "10y");
            this.hidden = true;
        },
    },
    created() {
        this.supported = isSupported();
        this.hidden = this.$cookies.get(COOKIE_KEY) == "hidden";
    },
};
</script>

<style></style>
